import Cookies from 'universal-cookie';

export const COOKIES_SESSION = 'victory_session';
export const COOKIES_CUSTOMER_ID = 'victory_id';
export const COOKIES_CURRENT_LOC = 'current_loc';
export const COOKIES_STATUS_UL = 'status_ul';
export const COOKIES_REG_ID_UL = 'reg_id';
export const COOKIES_WSMM = 'slswsmm';
export const COOKIES_BRANCH_WSMM = 'brcwsmm';

const cookies = new Cookies();

export function saveCookies(key, data) {
  if (data === undefined) { data = null; }
  if (data !== null) {
    cookies.set(key, data, { path: '/', maxAge : 31536000 });
    // localStorage.setItem(key, data);
  }
}

export function getCookies(key) {
  let data = cookies.get(key);
  // let data = localStorage.getItem(key);
  if (data === undefined) { data = null; }
  return data;
}

export function removeCookies(key) {
  cookies.remove(key, { path: '/' });
  // localStorage.removeItem(key);
}

export function clearCookies() {
  cookies.remove(COOKIES_SESSION, { path : '/' });
  cookies.remove(COOKIES_CUSTOMER_ID, { path : '/' });
  cookies.remove(COOKIES_STATUS_UL, { path : '/' });
  cookies.remove(COOKIES_REG_ID_UL, { path : '/' });
  cookies.remove(COOKIES_WSMM, { path : '/' });
  cookies.remove(COOKIES_BRANCH_WSMM, { path : '/' });
  // localStorage.removeItem(COOKIES_SESSION);
  // localStorage.removeItem(COOKIES_CUSTOMER_ID);
}
